export function ModalTitle(props) {
    return <span className="text-center text-xl font-mono font-bold">{props.children}</span>;
}
